const components = [
  {
    title: "默认背景",
    tag: "de-background",
    type: "background",
    props: [
        {
            title: "颜色",
            name: "color",
            type: {
              name: "color"
            },
            default:"#000000"
        },
        {
          title: "图片",
          name: "image",
          type: {
            name: "image"
          },
          default:""
        },
        {
          title: "图像宽度",
          name: "width",
          type: {
            name: "number-unit",
            options: {
              units: [
                {
                  value: "px",
                  label: "像素"
                },
                {
                  value: "%",
                  label: "百分比"
                }
              ]
            }
          },
          default:{
              value:100, unit:'%'
          }
        },
        {
          title: "图像高度",
          name: "height",
          type: {
              name: "number-unit",
              options: {
                units: [
                  {
                    value: "px",
                    label: "像素"
                  },
                  {
                    value: "%",
                    label: "百分比"
                  }
                ]
              }
            },
            default:{
              value:100, unit:'%'
          }
        },
        {
          title: "重复",
          name: "repeat",
          type: {
            name: "select1",
            options: {
              options: [
                {
                  value: "no-repeat",
                  label: "不重复"
                },
                {
                  value: "repeat",
                  label: "XY轴都重复"
                },
                {
                  value: "repeat-x",
                  label: "X轴重复"
                },
                {
                  value: "repeat-y",
                  label: "Y轴重复"
                }
              ]
            }
          }
        }
    ]
  }
];

export { components };
